// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface ProductFeedbackModel {
    ItemCode: string;
    Sku: string;
    FeedbackMessage: string;
}

export async function productFeedback(data: ProductFeedbackModel): Promise<ServiceResult<string>> {
    try {
        const ccSuccess = await post<ProductFeedbackModel, string>("/api/cmi/productFeedback/submit", data);
        return {
            result: ccSuccess,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400) {
            return {
                successful: false,
                errorMessage: error as string,
            };
        }
        return {
            successful: false,
            errorMessage: error as string,
        };
    }
}
